"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: [String, Array],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    autoClose: {
        type: Boolean,
        default: undefined
    },
    autoWidth: {
        type: Boolean,
        default: undefined
    },
    checkAll: {
        type: Boolean,
        default: undefined
    },
    checkAllTemplate: {
        type: [String, Function],
        default: undefined
    },
    checkboxes: {
        type: [Boolean, Object],
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    dataImageUrlField: {
        type: String,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    },
    dataTextField: {
        type: [String, Array],
        default: undefined
    },
    dataUrlField: {
        type: String,
        default: undefined
    },
    dataValueField: {
        type: [String, Array],
        default: undefined
    },
    delay: {
        type: Number,
        default: undefined
    },
    enable: {
        type: Boolean,
        default: undefined
    },
    enforceMinLength: {
        type: Boolean,
        default: undefined
    },
    filter: {
        type: String,
        default: undefined
    },
    footerTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: [String, Number],
        default: undefined
    },
    ignoreCase: {
        type: Boolean,
        default: undefined
    },
    loadOnDemand: {
        type: Boolean,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    minLength: {
        type: Number,
        default: undefined
    },
    noDataTemplate: {
        type: [String, Function],
        default: undefined
    },
    placeholder: {
        type: String,
        default: undefined
    },
    popup: {
        type: Object,
        default: undefined
    },
    headerTemplate: {
        type: [String, Function],
        default: undefined
    },
    valueTemplate: {
        type: [String, Function],
        default: undefined
    },
    tagMode: {
        type: String,
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    text: {
        type: String,
        default: undefined
    },
    value: {
        type: [String, Array],
        default: undefined
    },
    valuePrimitive: {
        type: Boolean,
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    filtering: Function,
    open: Function,
    select: Function
};